import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import { Login, Register, RegisterCompany, SelectAccountType } from "./pages/Auth";
import Plans from "./pages/Plans";
import Dashboard from "./pages/Dashboard";
import ReviewForm from "./pages/ReviewForm";
import { PaymentSuccess, PaymentFailure, PaymentPending } from "./pages/PaymentResult";
import Sobre from "./pages/Sobre";
import Duvidas from "./pages/Duvidas";
import Contato from "./pages/Contato";
import Empresas from "./pages/Empresas";
import ParaElas from "./pages/ParaElas";
import CompletarCurriculo from "./pages/CompletarCurriculo";
import MeuPerfil from "./pages/MeuPerfil";
import MinhasAvaliacoes from "./pages/MinhasAvaliacoes";
import VagasSalvas from "./pages/VagasSalvas";
import Configuracoes from "./pages/Configuracoes";
import NotFound from "./pages/NotFound";
// Admin interno (sem branding)
import LoginAdmin from "./pages/admin-interno/LoginAdmin";
import AdminLayout from "./pages/admin-interno/AdminLayout";
import AdminDashboard from "./pages/admin-interno/Dashboard";
import EmpresasAdmin from "./pages/admin-interno/EmpresasAdmin";
import AvaliacoesAdmin from "./pages/admin-interno/AvaliacoesAdmin";
import VagasAdmin from "./pages/admin-interno/VagasAdmin";
import MulheresAdmin from "./pages/admin-interno/MulheresAdmin";
import LogsAdmin from "./pages/admin-interno/LogsAdmin";
import RedefinirSenha from "./pages/admin-interno/RedefinirSenha";

import AuthRedirectHandler from "./components/AuthRedirectHandler";
import { EsqueciSenha, NovaSenha } from "./pages/RecuperarSenha";

import { globalCSS } from "./components/UI";

// Componente para rotas publicas com Navbar e Footer
function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <>
      <style>{globalCSS}</style>
      <AppProvider>
        <BrowserRouter>
          <AuthRedirectHandler>
            <Routes>
            {/* Rotas publicas com layout */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
            <Route path="/cadastro" element={<PublicLayout><SelectAccountType /></PublicLayout>} />
            <Route path="/cadastro-mulher" element={<PublicLayout><Register /></PublicLayout>} />
            <Route path="/cadastro-empresa" element={<PublicLayout><RegisterCompany /></PublicLayout>} />
            <Route path="/planos" element={<PublicLayout><Plans /></PublicLayout>} />
            <Route path="/avaliar" element={<PublicLayout><ReviewForm /></PublicLayout>} />
            <Route path="/dashboard" element={<PublicLayout><Dashboard /></PublicLayout>} />
            <Route path="/pagamento/sucesso" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
            <Route path="/pagamento/falha" element={<PublicLayout><PaymentFailure /></PublicLayout>} />
            <Route path="/pagamento/pendente" element={<PublicLayout><PaymentPending /></PublicLayout>} />
            <Route path="/sobre" element={<PublicLayout><Sobre /></PublicLayout>} />
            <Route path="/duvidas" element={<PublicLayout><Duvidas /></PublicLayout>} />
            <Route path="/contato" element={<PublicLayout><Contato /></PublicLayout>} />
            <Route path="/empresas" element={<PublicLayout><Empresas /></PublicLayout>} />
            <Route path="/para-elas" element={<PublicLayout><ParaElas /></PublicLayout>} />
            <Route path="/completar-curriculo" element={<PublicLayout><CompletarCurriculo /></PublicLayout>} />
            <Route path="/meu-perfil" element={<PublicLayout><MeuPerfil /></PublicLayout>} />
            <Route path="/minhas-avaliacoes" element={<PublicLayout><MinhasAvaliacoes /></PublicLayout>} />
            <Route path="/esqueci-senha" element={<PublicLayout><EsqueciSenha /></PublicLayout>} />
            <Route path="/nova-senha" element={<PublicLayout><NovaSenha /></PublicLayout>} />
            <Route path="/vagas-salvas" element={<PublicLayout><VagasSalvas /></PublicLayout>} />
            <Route path="/configuracoes" element={<PublicLayout><Configuracoes /></PublicLayout>} />

            {/* URLs obivas de admin retornam 404 */}
            <Route path="/admin" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/admin/*" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/painel" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/painel/*" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/dashboard-admin" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/dashboard-admin/*" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/backoffice" element={<PublicLayout><NotFound /></PublicLayout>} />
            <Route path="/backoffice/*" element={<PublicLayout><NotFound /></PublicLayout>} />

            {/* Rotas do admin interno (sem Navbar/Footer) */}
            <Route path="/acesso-interno-bt" element={<LoginAdmin />} />
            <Route path="/acesso-interno-bt/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/acesso-interno-bt/*" element={<AdminLayout />}>
              <Route path="painel" element={<AdminDashboard />} />
              <Route path="empresas" element={<EmpresasAdmin />} />
              <Route path="avaliacoes" element={<AvaliacoesAdmin />} />
              <Route path="vagas" element={<VagasAdmin />} />
              <Route path="mulheres" element={<MulheresAdmin />} />
              <Route path="logs" element={<LogsAdmin />} />
            </Route>

            {/* 404 para rotas nao encontradas */}
            <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
          </Routes>
          </AuthRedirectHandler>
        </BrowserRouter>
      </AppProvider>
    </>
  );
}
